import { createThemedStyles } from '@repo/theme/styles';
import { Pad, VertBox } from 'component/basics';
import { UtilityText } from 'component/text';
import { Image, View } from 'react-native';
import type { TLabel } from 'util/stdtypes';
import { makeAssetUrl } from 'util/util';

export function EmptyTableBanner({ label }: { label: TLabel }) {
    const s = useEmptyTableBannerStyles();
    return (
        <View style={s.banner}>
            <VertBox center>
                <Image source={{ uri: makeAssetUrl('images/spaces.png') }} style={s.image} />
                <Pad size={12} />
                <UtilityText center label={label} type='large' weight='medium' />
            </VertBox>
        </View>
    );
}

const useEmptyTableBannerStyles = createThemedStyles((tokens) => ({
    banner: {
        backgroundColor: tokens.colors.colorSurfaceSecondary,
        borderRadius: 8,
        padding: 24,
    },
    image: {
        width: 133,
        height: 80,
    },
}));
